/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { Inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { BehaviorSubject } from 'rxjs';
import { FCM } from '@awesome-cordova-plugins/fcm/ngx';
import { Platform } from '@ionic/angular';
import { AngularFireMessaging } from '@angular/fire/messaging';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  onUpdate: BehaviorSubject<any> = new BehaviorSubject(undefined);
  notifications = [];
  roughWorkId = 'VLn1nMsT5SNebvvBoNs3';
  currentUser;
  lastActiveTimestamp = localStorage.getItem('lastActiveTimestamp');
  recentCount;
  unsubscribe2;
  constructor(
    public firestore: AngularFirestore,
    public auth: AngularFireAuth,
    public messaging: AngularFireMessaging,
    public fcm: FCM,
    public platform: Platform,
    public toastController: ToastController
  ) {


    this.auth.authState.subscribe(user => {
      if (user) {
        this.initializeFCM();
        this.notifications = [];
        this.getUser(user.uid).then((currentUser) => {
          this.currentUser = currentUser;
          this.setMessagesNotifications(this.currentUser);
        });
      };
    });
  }

  async setMessagesNotifications(currentUser) {
    if (currentUser?.id) {
      this.unsubscribe2 = this.firestore.collection('notifications', ref => ref.where('to', '==', currentUser.id).orderBy('timestamp', 'desc').limit(100)).snapshotChanges().subscribe(async (snapshot) => {
        snapshot.forEach(async (change) => {
          let notification: any = {};
          if (change.type === 'added') {
            notification = { id: change.payload.doc.id, ...((change.payload.doc.data() as any) || {}) };
            if (notification.id !== this.roughWorkId) {
              notification.to = await this.getUserByid(notification.to);
              notification.by = await this.getUserByid(notification.by);
              this.notifications.push(notification);
            }
          }
          if (change.type === 'modified') {
            notification = { id: change.payload.doc.id, ...((change.payload.doc.data() as any) || {}) };
            if (notification.id !== this.roughWorkId) {
              notification.to = await this.getUserByid(notification.to);
              notification.by = await this.getUserByid(notification.by);
              const index = this.notifications.findIndex(item => item.id === notification.id);
              this.notifications[index] = notification;
            }
          }
          if (change.type === 'removed') {
            this.notifications = this.notifications.slice(this.notifications.findIndex(item => item.id === change.payload.doc.id));
          }
          setTimeout(() => {
            // console.log(this.notifications);
            this.recentCount = this.notifications.filter(item => item.recent).length;
            this.onUpdate.next(this.notifications);
          }, 1000);
        });
      });
    }
  }


  async getUserByid(id) {
    const docSnap = await this.firestore.collection('accounts').doc(id).get().toPromise();
    if (docSnap.exists) {
      const account: any = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
      return account;
    }
    return undefined;
  }



  async getUser(uid) {
    let data;
    const user = await this.firestore.collection('accounts', ref => ref.where('uid', '==', uid).limit(1)).get().toPromise();
    user.forEach(docRef => {
      data = docRef.data();
      data.id = docRef.id;
    });
    return data;
  }

  notificationRead(id) {
    this.notifications = this.notifications.slice(this.notifications.findIndex(item => item.id === id));
    this.firestore.collection('notifications').doc(id).update({ recent: false }).then(() => { });
  }

  deleteNotification(id) {
    this.notifications = this.notifications.slice(this.notifications.findIndex(item => item.id === id));
    this.firestore.collection('notifications').doc(id).delete();
  }


  async sendNotification(title, body, data, image, collapseKey, topic) {
    console.log(title, body, data, image, collapseKey, topic);

    const payload = {
      notification: {
        title,
        body,
        image: image ? image : undefined,
        icon: 'assets/icon/logo.png',
        click_action: data.redirectURL,
        link: data.redirectURL,
      },
      data,
      collapseKey,
      topic,
      to: data.to,
      by: data.by,
      redirectURL: data.redirectURL,
      timestamp: new Date(),
      type: data.type,
    };
    Object.keys(payload).forEach(key => {
      if (payload[key] === undefined || payload[key] === null) {
        delete payload[key];
      }
    });
    Object.keys(payload.notification).forEach(key => {
      if (payload.notification[key] === undefined || payload.notification[key] === null) {
        delete payload.notification[key];
      }
    });
    Object.keys(payload.data).forEach(key => {
      if (payload.data[key] === undefined || payload.data[key] === null) {
        delete payload.data[key];
      }
    });
    console.log(payload);
    await this.firestore.collection('notifications').doc(this.roughWorkId).update(payload);
    await this.addNotification(payload);
  }


  async addNotification(payload) {
    delete payload.id;
    payload['recent'] = true;
    return await this.firestore.collection('notifications').add({
      ...payload,
    });
  }



  initializeFCM() {
    if (this.platform.is('cordova') && (this.platform.is('android') || this.platform.is('ios'))) {
      this.fcm.getToken().then(token => {
        console.log(token);
        this.saveToken(token);
      });

      this.fcm.onNotification().subscribe(data => {
        if (data.wasTapped) {
          console.log('Received in background tapped');
          this.recivedNotification(data);
        } else {
          console.log('Received in foreground');
          this.recivedNotification(data);
        };
      });

      this.fcm.onTokenRefresh().subscribe(token => {
        console.log(token);
        this.saveToken(token);
      });

      this.fcm.hasPermission().then(hasPermission => {
        if (hasPermission) {
          console.log('Has permission!');
        }
      });

      this.fcm.clearAllNotifications();
    }
    if (!this.platform.is('cordova')) {
      Notification.requestPermission().then((permission) => {
        console.log('Notification=======>>>>>>>>>>>>>', permission);
        if (permission === 'granted') {
          console.log('Notification permission granted.', permission);
          this.messaging.getToken.subscribe({
            next: (currentToken) => {
              if (currentToken) {
                // Send the token to your server and update the UI if necessary
                localStorage.setItem('tokenGranted', 'true');
                window.dispatchEvent(new CustomEvent('notification-tokenGranted'));
                this.saveToken(currentToken);
              } else {
                // Show permission request UI
                this.presentPermissionToast('Allow Notifications');
                console.log('No registration token available. Request permission to generate one.');
                localStorage.setItem('tokenGranted', 'false');
              }
            },
            error: (err) => {
              console.log('An error occurred while retrieving token. ', err);
              localStorage.setItem('tokenGranted', 'false');
            }
          });
        }
        if (permission === 'default') {
          this.presentPermissionToast('Allow Notifications Please!');
          localStorage.setItem('tokenGranted', 'false');
        }
        if (permission === 'denied') {
          // this.presentPermissionToast('Please! Allow Notifications');
          // this.presentToast('Notification Permission Denied, may ask later!');
          localStorage.setItem('tokenGranted', 'false');
        }
      });
      this.messaging.messages.subscribe((payload) => {
        console.log('Message received. ', payload);
        this.recivedNotification(payload);
      });
    }
  }

  recivedNotification(payload) {
    console.log(payload);
    if (payload.collapseKey === 'connection') {

    }
    this.presentFCMToast(payload.notification.title, payload.notification.body);
  }

  async presentPermissionToast(header) {
    // const toast = await this.toastController.create({
    //   header,
    //   message: 'Click Allow Above To Get Nofifications Faster',
    //   icon: 'information-circle',
    //   position: 'middle',
    //   cssClass: 'ask-permission-toast',
    //   buttons: [
    //     {
    //       side: 'end',
    //       icon: 'checkmark',
    //       text: 'Allow',
    //       handler: () => {
    //         this.initializeFCM();
    //       }
    //     }
    //   ]
    // });
    // await toast.present();
    // window.addEventListener('notification-tokenGranted', () => {
    //   toast.dismiss();
    // });
    // const { role } = await toast.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }

  async presentToast(message) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  async presentFCMToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }


  async saveToken(token) {
    if (!this.currentUser?.uid) {
      console.warn('Cannot save token: currentUser or uid is undefined');
      return;
    }

    let user;
    const userRef = await this.firestore.collection('accounts', ref => ref.where('uid', '==', this.currentUser.uid).limit(1)).get().toPromise();
    userRef.forEach(docRef => {
      user = docRef.data();
      user.id = docRef.id;
    });
    if (user) {
      this.currentUser = user;
      console.log(this.currentUser);
      let tokens: Array<any> = Array.isArray(this.currentUser?.notificationTokens) ? this.currentUser?.notificationTokens : [];
      if (!tokens.includes(token)) {
        tokens.unshift(token);
        tokens = tokens.slice(0, 3);
      }
      this.firestore.collection('accounts').doc(user.id).update({
        notificationToken: token,
        notificationTokens: tokens,
      });
    }
  }

}
